import React, { Component } from 'react'
import Popup from './Popup'
import styled from 'styled-components'
import { Form, Input, Checkbox } from 'formsy-react-components';
import { Row, Col } from 'react-bootstrap';
import './popup.css'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject, observer } from 'mobx-react';
import { instanceOf } from 'prop-types';
import Parse from 'parse';

import whatsappIcon from '../../../images/icons/share/whatsapp.png'
import mailIcon from '../../../images/icons/share/mail.png'

import { withCookies, Cookies } from 'react-cookie';

import config from 'react-global-configuration';

@inject('userStore')

@observer
class SharePopup extends Component {

  constructor(props) {
      super(props)
      this.state = {}

      this.openModal = this.openModal.bind(this)

      Parse.Config.get().then(config => {
        this.setState({ shareUrl: config.get("SHARE_URL"), shareText: config.get("SHARE_TEXT"), shareSubject: config.get("SHARE_SUBJECT")})
      })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userStore.showSharePopup !== this.props.userStore.showSharePopup) {
      this.setState({ open: this.props.userStore.showSharePopup })

      if(this.state.open && this.props.reopen)
        this.child.openModal()
    }
  }

  openModal() {
  }

  copyToClipBoard = async () => {
    if(navigator.clipboard) {
      await navigator.clipboard.writeText(this.state.shareText + " " + this.state.shareUrl)
      this.setState({shareMessage: "Text kopiert!"})
      setTimeout(() => {
        this.setState({shareMessage: undefined})
      }, 3000);
    } else {
      this.setState({shareMessage: "Fehler!"})
    }
  }

  render() {

    return (
      <Popup width="400px" height="auto" centered dismissable ref={instance => { this.child = instance; }} open={this.props.userStore.showSharePopup} onClose={() => this.props.userStore.setShowSharePopup(false)}>
        <Heading>Tell a Friend</Heading>

        <Col md={12} lg={6} style={{padding: 10}}>
          <LogeButtonSlim
            onClick={ () => window.open("https://wa.me/?text=" + encodeURIComponent(this.state.shareText + " " + this.state.shareUrl), "_blank") }
            style={{ backgroundColor: '#DAB777', border: "none", width: "100%", margin: 0}}
            hoverFontColor={"white"}
            color="#bea06a"
            fontColor={"white"}
          >
            <Icon src={whatsappIcon} /> Whatsapp
          </LogeButtonSlim>
        </Col>
        <Col md={12} lg={6} style={{padding: 10}}>
          <LogeButtonSlim
            onClick={ () => window.open("mailto:?subject="+ encodeURIComponent(this.state.shareSubject) +"&body=" + encodeURIComponent(this.state.shareText + " " + this.state.shareUrl), "_blank") }
            style={{ backgroundColor: '#DAB777', border: "none", width: "100%", margin: 0}}
            hoverFontColor={"white"}
            color="#bea06a"
            fontColor={"white"}
          >
            <Icon src={mailIcon} /> Email
          </LogeButtonSlim>
        </Col>

        <br /><a onClick={ () => { this.child.closeModal() }} style={{cursor: "pointer"}}>schließen</a>
      </Popup>
    )
  }
}

SharePopup.propTypes = {
  cookies: instanceOf(Cookies).isRequired
};

export default withCookies(SharePopup);

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`

const Icon = styled.img `
  height 1.5em;
  display: inline-block;
  width: 100%;
  object-fit: contain;
  margin-bottom: 0.5em;
`

const ShareLink = styled.a `
  color: #DAB777;
  display: block;
  padding: 10px;
`



// WEBPACK FOOTER //
// /src/components/internal/Popups/SharePopup.js